var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMobile = function SvgIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F2F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6EBE6",
    d: "M21 7.05h18c2.48 0 4.5 1.98 4.5 4.4v35.23c0 2.42-2.02 4.4-4.5 4.4H21a4.47 4.47 0 0 1-4.5-4.4V11.46c0-2.43 2.02-4.4 4.5-4.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-mobile_svg__a)",
    d: "M39 52.55H21c-3.3 0-6-2.64-6-5.87V11.46c0-3.23 2.7-5.87 6-5.87h18c3.3 0 6 2.64 6 5.87v35.22c0 3.23-2.7 5.87-6 5.87M21 8.52c-1.65 0-3 1.32-3 2.94v35.22a2.98 2.98 0 0 0 3 2.94h18c1.65 0 3-1.32 3-2.94V11.46a2.98 2.98 0 0 0-3-2.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-mobile_svg__b)",
    d: "M33.75 11.46h-7.5c-1.65 0-3-1.32-3-2.94h13.5a2.98 2.98 0 0 1-3 2.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-mobile_svg__c)",
    d: "M30 37.88c4.97 0 9-3.95 9-8.81a8.9 8.9 0 0 0-9-8.8 8.9 8.9 0 0 0-9 8.8 8.9 8.9 0 0 0 9 8.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4A76",
    d: "M30 36.4c4.14 0 7.5-3.28 7.5-7.33a7.42 7.42 0 0 0-7.5-7.34 7.42 7.42 0 0 0-7.5 7.34 7.42 7.42 0 0 0 7.5 7.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-mobile_svg__d)",
    d: "M30 32c-.45 0-.23.08-3.52-3.15a.7.7 0 0 1 0-1.03c.3-.3.75-.3 1.04 0L30 30.24l3.98-3.89c.3-.29.75-.29 1.05 0 .3.3.3.74 0 1.03-4.96 4.85-4.58 4.63-5.03 4.63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-mobile_svg__e)",
    d: "M37.5 46.68h-15c-.45 0-.75-.3-.75-.73 0-.44.3-.73.75-.73h15c.45 0 .75.29.75.73s-.3.73-.75.73"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-mobile_svg__a",
    x1: 15,
    x2: 45,
    y1: 29.07,
    y2: 29.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-mobile_svg__b",
    x1: 23.25,
    x2: 36.75,
    y1: 9.99,
    y2: 9.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-mobile_svg__c",
    x1: 21,
    x2: 39,
    y1: 29.07,
    y2: 29.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C4A76",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C4A76",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-mobile_svg__d",
    x1: 26.25,
    x2: 35.25,
    y1: 29.07,
    y2: 29.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-mobile_svg__e",
    x1: 21.75,
    x2: 38.25,
    y1: 45.95,
    y2: 45.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CCDA"
  })))));
};
export default SvgIconMobile;